<template>
  <v-card
    class="editQuestionComponent mb-4"
    elevation="0"
  >
    <v-card-title>
      Question {{ number }}
      <v-spacer />
      <v-btn
        v-if="number != 1"
        title="Move Question Up"
        small
        icon
        class="move-question-up"
        color="secondary"
        @click="moveQuestionUp()"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
      <v-btn
        v-if="number != total"
        title="Move Question Down"
        small
        icon
        class="move-question-down"
        color="secondary"
        @click="moveQuestionDown()"
      >
        <v-icon>mdi-arrow-down</v-icon>
      </v-btn>
      <v-btn
        title="Delete Question"
        class="delete-question"
        text
        icon
        color="red"
        @click="deleteQuestionFromSection()"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <EditTextQuestionComponent
        v-if="checkTypeName(questionCopy.question_type.name)"
        :question="questionCopy"
        :types="types"
      />
      <EditTextModalQuestionComponent
        v-if="questionCopy.question_type.type === 'text-modal'"
        :question="questionCopy"
        :types="types"
      />
      <EditOptionsQuestionComponent
        v-if="questionCopy.question_type.needs_options"
        :question="questionCopy"
        :types="types"
      />
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'EditQuestionComponent',
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    number: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    questionCopy: {
      question_type: {}
    }
  }),
  computed: {
    types () {
      return this.$store.state.questions.types || []
    }
  },
  watch: {
    question (newQuestion, oldQuestion) {
      this.questionCopy = newQuestion
    }
  },
  created () {
    this.questionCopy = this.question
  },
  methods: {
    moveQuestionUp () {
      this.$emit('moveQuestionUp', this.questionCopy)
    },
    moveQuestionDown () {
      this.$emit('moveQuestionDown', this.questionCopy)
    },
    deleteQuestionFromSection () {
      this.$emit('deleteQuestion', this.questionCopy)
    },
    updateOptions (options) {
      this.questionCopy.question_options = options
    },
    checkTypeName (name) {
      return _.includes(['Number', 'Text', 'Phone', 'Email', 'Date Picker', 'Signature', 'Signature (Combined)'], name)
    }
  }
}
</script>
<style lang="scss">
.editQuestionComponent {
    position: relative;
    padding: 1rem 1rem 2.5rem;
    .row > * {
        padding-top: 0;
        padding-bottom: 0;
    }
    .v-list-item__content{
        padding: 16px 0;
    }
}
</style>
